export default __webpack_public_path__ + "static/input-validation-state-c86458fd6a22f43952d839adddf0de05.png";